import cn from 'classnames';
import React from 'react';
import { DetailsInfo, ICard } from '../../../../types/Card';
import { DH } from '../../../../utils/DataHook';
import { t } from '../../../../utils/i18n';
import s from './styles.scss';

export interface ICardDetailsProps extends Pick<ICard, DetailsInfo> {
  mobile?: boolean;
}

export const CardDetails: React.FC<ICardDetailsProps> = (props) => {
  const { billingAddress = {}, additionalInformation, mobile } = props;

  const shouldShowBillingAddress = () => {
    // const keys = Object.keys(billingAddress).filter((key) => !!billingAddress[key]);
    //
    // return keys.length !== 0 && (keys.length > 1 || keys[0] !== 'email');

    // NOTE: billing address will be retrieved from address book in the next phases of Wallet implementation
    return false;
  };

  return (
    <div
      data-hook={DH.CardDetails.Container}
      className={cn(s.detailsContainer, {
        [s.mobile]: mobile,
        [s.desktop]: !mobile,
      })}
    >
      {additionalInformation && (
        <div className={s.additionalInfo}>
          <div className={s.title}>{t('app.card.details.additional-details-title')}:</div>
          <div className={s.content}>
            {t('app.card.details.name-on-card')}: {additionalInformation.holderName}
          </div>
        </div>
      )}
      {shouldShowBillingAddress() && (
        <div data-hook={DH.CardDetails.BillingAddress} className={s.billingAddress}>
          <div className={s.title}>{t('app.card.details.billing-address-title')}:</div>
          <div className={s.content}>
            <div>
              {billingAddress.firstName} {billingAddress.lastName}
            </div>
            <div>{billingAddress.company}</div>
            {billingAddress.addressDetails && (
              <div>
                {billingAddress.addressDetails.houseNumber} {billingAddress.addressDetails.street}{' '}
                {billingAddress.address}
              </div>
            )}
            <div>
              {billingAddress.city} {billingAddress.state} {billingAddress.zipCode}
            </div>
            <div>{billingAddress.countryCode}</div>
            <div>{billingAddress.phone}</div>
          </div>
        </div>
      )}
    </div>
  );
};
CardDetails.displayName = 'CardDetails';
